<template>
  <transition name="modal">
    <div v-if="visible" class="modal-overlay">
      <div class="modal-content">
        <h3>增加觀測的股票</h3>
        <form @submit.prevent="handleSubmit">
          <input
            v-model="stockNumber"
            type="text"
            placeholder="請輸入股票編號(如:台積電 2330)"
            required
            class="input-field"
          />
          <button type="submit" :disabled="loading" class="add-button">
            {{ loading ? "增加中..." : "確定" }}
          </button>
          <button @click="closeModal" class="close-button">關閉</button>
        </form>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: "AddStock",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    account: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      stockNumber: "",
      loading: false,
    };
  },
  methods: {
    async handleSubmit() {
      console.log("Account: ", this.account);
      if (!this.stockNumber) return; // Basic validation
      this.loading = true;
      try {
        const stocks = this.stockNumber.split(",");
        await this.$store.dispatch("addStock", { stocks });
        console.log(this.account, " Stock added successfully");
        this.$emit("stock-added");
        this.closeModal();
      } catch (error) {
        console.error("Failed to add stock:", error);
        alert("Error adding stock. Please try again.");
      } finally {
        this.loading = false;
      }
    },
    closeModal() {
      this.stockNumber = ""; // Reset input
      this.$emit("close"); // Emit close event to parent
    },
  },
};
</script>

<style lang="scss" scoped>
$primary: #4dba87;

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-content {
  background: white;
  padding: 20px;
  border-radius: 8px;
  width: 100%;
  max-width: 300px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.modal-content h3 {
  margin-top: 0;
  color: $primary;
}

.input-field {
  display: block;
  width: 80%;
  padding: 10px;
  margin: 10px 0;
  border: 1px solid darken($primary, 20%);
  border-radius: 4px;
  font-size: 16px;
}

.add-button,
.close-button {
  padding: 10px 20px;
  margin: 10px 5px 0;
  border: none;
  border-radius: 4px;
  font-size: 16px;
  cursor: pointer;
}

.add-button {
  background: $primary;
  color: white;
  &:hover {
    background: darken($primary, 10%);
  }
  &:disabled {
    background: darken($primary, 20%);
    cursor: not-allowed;
  }
}

.close-button {
  background: #ccc;
  color: #333;
  &:hover {
    background: darken(#ccc, 10%);
  }
}

.modal-enter-active,
.modal-leave-active {
  transition: opacity 0.3s;
}
.modal-enter-from,
.modal-leave-to {
  opacity: 0;
}
</style>
